PJQ.views.directcosts.DirectCostEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DIRECTCOSTS, 'modal-direct-cost-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveDirectCost',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-delete': 'deleteDirectCost',
        'click .btn-export': 'exportDirectCost',
        'click .btn-close': 'close',
        'click .btn-email': 'email',
        'click .nav-link': 'activeViewChanged'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = PJQ.app.session.project;
        this.options.isAdmin = PJQ.app.session.project.hasPermission('directCosts.isAdmin');

        this.coreFieldSettings = await PJQ.app.session.fetchDirectCostFieldSettings();
        this.settings = await PJQ.app.session.fetchDirectCostSettings();
        this.customFields = await this.options.project.fetchDirectCostCustomFields();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        if (this.model == null) {
            let customFieldValues = [];

            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            this.model = new PJQ.models.directcosts.DirectCost({
                type: PJQ.constants.directcosts.directCostType.EXPENSE,
                description: '',
                terms: '',
                projectId: PJQ.app.session.project.id,
                statusId: PJQ.constants.directcosts.directCostStatus.DRAFT,
                accountingMethod: this.settings.get('defaultAccountingMethod'),
                customFieldValues: customFieldValues
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.disabledStatuses = [];
        this.options.canEdit = this.options.project.hasPermission('directCosts.canEdit');
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;
        if (this.model != null) {
            let status = this.model.get('statusId');
            if (status === PJQ.constants.directcosts.directCostStatus.DRAFT) {
                this.options.canEdit = true;
            } else if (status === PJQ.constants.directcosts.directCostStatus.APPROVED) {
                this.options.canDelete = false;
                this.options.canEdit = this.options.canEdit && this.model.isNew();
            } else {
                this.options.canEdit = PJQ.app.session.project.hasPermission('directCosts.canEdit');
            }

            if (this.erpIntegration != null) {
                let syncStatus = this.model.erpSyncStatus();
                if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                    || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                    || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
                ) {
                    this.options.canEdit = false;
                    this.options.canEditLineItems = false;
                    this.options.canDelete = false;
                    this.options.canEditStatus = false;
                }
            }
        }
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            model: this.model,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            canDelete: this.options.canDelete,
            erpIntegration: this.erpIntegration,
            activeView: this.options.activeView,
            views: this.views,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this)
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.activateView(this.options.activeView);

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();
        this.renderLineItems();
        this.updateCounts();
        this.renderTotals();
    },
    updateCounts: function () {
        // todo: fix this to account for deleted items on an existing model
        this.$('.count-line-items').text(_.size(this.model.lineItems.models));
    },
    views: {
        GENERAL: 'D_General',
        LINEITEMS: 'D_LineItems'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        switch (view) {
            case this.views.LINEITEMS:
                // do nothing
                break;
            default:
                view = this.views.GENERAL;
                break;
        }
        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        if (this.checkFieldVisible('type')) {
            this.typeSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.direct-cost-type'),
                isIntChoices: true,
                canEdit: this.options.canEdit,
                defaultValue: this.model.get('type'),
                onHide: _.bind(function () {
                    this.model.set('type', this.typeSelectPicker.getValue());
                }, this)
            });
        }

        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            isIntChoices: true,
            canEdit: this.options.canEditStatus,
            defaultValue: this.model.get('statusId'),
            choices: _.map(PJQ.constants.directcosts.directCostStatus, (st) => {
                return {
                    id: st,
                    name: PJQ.constants.directcosts.directCostStatusNames[st],
                    disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
                }
            }),
            onChange: (newStatus) => {
                let oldStatus = this.model.get('statusId');
                if(newStatus === oldStatus){
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Direct Cost saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    });
                } else{
                    this.render();
                }
            }
        });

        if (this.checkFieldVisible('vendor')) {
            this.vendorPicker = new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.vendor'),
                selectedContact: this.model.vendor,
                hideUsers: true,
                canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
                canEdit: this.options.isAdmin && !this.model.isERPSynced(),
                displayContactsBlock: true,
                context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                isSingleChoice: true,
                onChange: _.bind(function (selectedContact) {
                    this.model.vendor = selectedContact;
                    this.model.set('vendorId', selectedContact ? selectedContact.get('contactId') : null);
                }, this)
            });
        }

        if (this.checkFieldVisible('reportedBy')) {
            this.reportedByPicker = new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.reported-by'),
                selectedContact: this.model.reportedBy,
                hideUsers: true,
                canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
                canEdit: this.options.isAdmin,
                displayContactsBlock: true,
                context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                isSingleChoice: true,
                onChange: _.bind(function (selectedContact) {
                    this.model.reportedBy = selectedContact;
                    this.model.set('reportedById', selectedContact ? selectedContact.id : null);
                }, this)
            });
        }

        if (this.checkFieldVisible('appliedOn')) {
            new PJQ.inputs.Datepicker({
                el: this.$('.applied-on'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('appliedOn') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('appliedOn'), false) : null
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('appliedOn', newDate);
                }, this)
            });
        }

        if (this.checkFieldVisible('receivedOn')) {
            new PJQ.inputs.Datepicker({
                el: this.$('.received-on'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('receivedOn') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('receivedOn'), false) : null
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('receivedOn', newDate);
                }, this)
            });
        }

        if (this.checkFieldVisible('paidOn')) {
            new PJQ.inputs.Datepicker({
                el: this.$('.paid-on'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('paidOn') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('paidOn'), false) : null
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('paidOn', newDate);
                }, this)
            });
        }

        if (_.size(this.customFields) > 0) {
            this.directCostCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.direct-cost-custom-fields'),
                isAdmin: true,
                isEdit: this.options.canEdit,
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.direct-cost-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                includeProjectAttachments: false,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }
    },
    renderLineItems() {
        if(this.lineItemsView){
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.direct-cost-line-items'),
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.directcosts.LineItem,
            accountingMethod: this.model.get('accountingMethod'),
            canEdit: this.options.canEdit,
            canDelete: this.options.canEdit,
            canChangeAccountingMethod: true,
            showGrandTotal: true,
            onAccountingMethodChanged: _.bind(function (value) {
                this.model.set('accountingMethod', value);
            }, this),
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.updateCounts();
            }, this)
        });
    },
    renderTotals: function () {
        let amount = 0,
            billed = 0;
        _.each(this.model.lineItems.models, function (lineItem) {
            amount += lineItem.get('amount');
            billed += lineItem.get('billedToDate');
        });
        this.$('.total-amount').text(PJQ.helpers.formatHelpers.formatCurrency(amount));
        this.$('.total-billed').text(PJQ.helpers.formatHelpers.formatCurrency(billed));
        this.$('.total-remaining').text(PJQ.helpers.formatHelpers.formatCurrency(amount - billed));
    },
    saveEmail: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Direct Cost saved successfully'
                });

                this.email();
            }
        });
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    saveDirectCost: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Direct Cost saved successfully'
                });

                this.removeModal();
            }
        });
    },
    validate: function () {
        let isValid = true;

        if (this.directCostCustomFieldsForm != null && !this.directCostCustomFieldsForm.validate()) {
            isValid = false;
        }

        if (this.checkFieldRequired('vendor')) {
            if (!this.vendorPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('reportedBy')) {
            if (!this.reportedByPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('appliedOn')) {
            let $appliedOn = this.$('.applied-on');
            PJQ.helpers.inputHelpers.setInputError($appliedOn, true);
            if (this.model.get('appliedOn') == null || this.model.get('appliedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($appliedOn, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('receivedOn')) {
            let $receivedOn = this.$('.received-on');
            PJQ.helpers.inputHelpers.setInputError($receivedOn, true);
            if (this.model.get('receivedOn') == null || this.model.get('receivedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($receivedOn, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('paidOn')) {
            let $paidOn = this.$('.paid-on');
            PJQ.helpers.inputHelpers.setInputError($paidOn, true);
            if (this.model.get('paidOn') == null || this.model.get('paidOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($paidOn, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('terms')) {
            let $terms = this.$('.terms');
            PJQ.helpers.inputHelpers.setInputError($terms, true);
            if (_.size(this.model.get('terms')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($terms, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('description')) {
            let $description = this.$('.description');
            PJQ.helpers.inputHelpers.setInputError($description, true);
            if (_.size(this.model.get('description')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($description, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('type')) {
            let $type = this.$('.direct-cost-type');
            PJQ.helpers.inputHelpers.setInputError($type, true);
            if (this.model.get('type') == null) {
                PJQ.helpers.inputHelpers.setInputError($type, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid && this.options.activeView !== 'general') {
            this.activateView(this.views.GENERAL);
            return isValid;
        }

        if (!this.lineItemsView.validate()) {
            isValid = false;

            this.activateView(this.views.LINEITEMS);
            return isValid
        }

        return isValid;
    },
    save: function (callback) {
        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        this.model.save({
            lineItems: this.model.lineItems.models,
            customFields: this.directCostCustomFieldsForm != null ? this.directCostCustomFieldsForm.getChanged() : null
        }, {
            success: _.bind(function () {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.options.project.trigger('directCostChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this),
            error: () => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this Direct Cost. Please contact customer service."
                });
            }
        });
    },
    deleteDirectCost: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this direct cost?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Direct cost deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete();

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Direct Cost has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Direct Cost",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Direct Cost email sent'
                    });
                }, this));
            }, this)
        });
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced()) {
            $erp.remove();
            return;
        }

        let canPush = true,
            disablePushReason = "";
        if (_.size(this.model.lineItems.models) === 0
            || this.model.get('statusId') !== PJQ.constants.directcosts.directCostStatus.APPROVED) {
            canPush = false;
            disablePushReason = "Direct Cost must be approved and have line items";
        }

        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: !this.model.isERPSynced() && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_DIRECT_COSTS),
            canPush: canPush,
            canPushChanges: false,
            disablePushReason: disablePushReason,
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_DIRECT_COSTS),
            status: this.model.erpSyncStatus()
        });
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_DIRECT_COSTS)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushDirectCost(this.model, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Direct Cost pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (callback && typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                });
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Direct Cost removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            }, this));
        }
    },
    unlinkERP: function () {
        if (this.erpIntegration != null) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.erpIntegration.unlinkDirectCost(this.model, _.bind(function (success) {
                if (success) {
                    loader.remove();
                    PJQ.notifications.notify.successNotify({
                        message: 'Direct Cost unlinked from ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    this.render();
                }
            }, this));
        }
    },
    exportDirectCost: function () {
        let callback = _.bind(function () {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.model.get('projectId')
                },
                {
                    endpoint: 'directcosts',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});
        }, this);

        if (this.options.canEdit && this.model.hasChanged()) {
            this.save(callback);
        } else {
            callback();
        }
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveDirectCost();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.directcosts.DirectCostSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DIRECTCOSTS, 'modal-direct-cost-settings'),
        minWidth: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.directCostView.userSettings;
    },
    beforeRender: function () {
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];

        this.options.defaultTypeFilter = this.userSettings.get('defaultTypeFilter');
        this.options.defaultStatusFilter = this.userSettings.get('defaultStatusFilter');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {
            let columns = this.options.directCostView.getDataTableInstance(setting.view).getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings
        }
    },
    afterRender: function () {
        let defaultFilter = {};
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER] = this.userSettings.get('defaultTypeFilter');
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER] = _.map(defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER], function (type) {
            return type * -1;
        });
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER] = this.userSettings.get('defaultStatusFilter');

        this.defaultFilterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter-default'),
            isIntChoices: true,
            isMultiple: true,
            isGrouped: true,
            mustSelectValuePerOptGroup: false,
            defaultValue: defaultFilter,
            onHide: _.bind(function () {
                this.options.defaultTypeFilter = this.defaultFilterSelectPicker.getValue()[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER];
                this.options.defaultTypeFilter = _.map(this.options.defaultTypeFilter, function (type) {
                    return type * -1;
                });

                this.options.defaultStatusFilter = this.defaultFilterSelectPicker.getValue()[PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER];
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(PJQ.constants.directcosts.view.DIRECT_COSTS);
    },
    editCompanySettings: function () {
        this.userSettings = new PJQ.models.directcosts.UserSettings(null, {
            forCompany: true
        });
        this.userSettings.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
            this.$('div.rows-per-page').show();
        } else
            this.$('div.rows-per-page').hide();

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {

        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.userSettings.set('defaultTypeFilter', this.options.defaultTypeFilter);
        this.userSettings.set('defaultStatusFilter', this.options.defaultStatusFilter);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        } else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.userSettings.save(null, {
            success: _.bind(function () {
                fnOnSave();
            }, this)
        });
    }
});
